module.exports = __webpack_public_path__ + "static/media/exchange-coin-icon.e407e6c0.svg";